import { API, api } from "@/lib/api";

const post = (url, body) =>
  fetch(`${API}${url}`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });

// Streams a Toth chat reply (SSE). onEvent receives {type: delta|tool|proposal|error|done, ...}.
export async function streamToth(sid, text, contextPath, onEvent) {
  const url = `/toth/chat/sessions/${sid}/messages`;
  let res = await post(url, { text, context_path: contextPath });
  if (res.status === 401) {
    await api.post("/auth/refresh");
    res = await post(url, { text, context_path: contextPath });
  }
  if (!res.ok) {
    let detail = "Errore imprevisto";
    try {
      detail = (await res.json()).detail || detail;
    } catch (e) {
      detail = res.statusText || detail;
    }
    throw new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.split("\n").find((l) => l.startsWith("data: "));
      if (line) onEvent(JSON.parse(line.slice(6)));
    }
  }
}
